import ModalMessages from "../../components/Modal/ModalSimpleButton";
import ModalTwoButtons from "../../components/Modal/ModalTwoButtons";

interface Button {
  text: string;
  action: () => void;
}

export interface Modal {
  title: string;
  description: string;
  button: Button;
  secondaryButton?: Button | null;
}
export interface ModalWrapperProps {
  modal: Modal;
}

export const ModalWrapper = ({ modal }: ModalWrapperProps) => {
  const isMessageModal = modal.secondaryButton === null || modal.secondaryButton === undefined;

  return isMessageModal ? (
    <ModalMessages
      title={modal.title}
      buttonText={modal.button.text}
      buttonAction={modal.button.action}
      open={modal !== null}
      setOpen={undefined}>
      <label>{modal.description}</label>
    </ModalMessages>
  ) : (
    <ModalTwoButtons
      title={modal.title}
      button1Text={modal.button.text}
      button1Action={modal.button.action || (() => {})}
      button2Text={modal.secondaryButton?.text || ""}
      button2Action={modal.secondaryButton?.action || (() => {})}
      open={modal !== null}
      setOpen={undefined}
      isButton1Disabled={undefined}
      isButton2Disabled={undefined}
      setClose={undefined}>
      <div style={{ textAlign: "center" }}>
        <label>{modal.description}</label>
      </div>
    </ModalTwoButtons>
  );
};
